import MainLayout from "@/components/layout/admin/MainLayout.vue";
import TwspNameJson from "@/assets/json/township.json";
import RegionJson from "@/assets/json/region.json";
import {
    required,
    maxLength,
} from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import $ from "jquery";
import axios from "axios";

export default {
    name: "JobCreate",
    components: {
        MainLayout,
        DatePicker
    },

    data() {
        return {
            company_id: "",
            company_name: "",
            category_id: "",
            category_name: "",
            job_title: "",
            min_salary: "",
            max_salary: "",
            job_type: "",
            description: "",
            short_desc: "",
            expired_date: "",
            gender: 1,
            experience: "",
            qualification: "",
            //   latitude: "",
            //   longitude: "",
            region: "",
            town: "",
            address: "",
            // facebook_post: 0,
            category: [],
            company: [],
            jobType: [{
                    value: "1",
                    name: "Full-time"
                },
                {
                    value: "2",
                    name: "Part-time"
                },
                {
                    value: "3",
                    name: "Internship"
                },
                {
                    value: "4",
                    name: "Freelance"
                },
                {
                    value: "5",
                    name: "Remote Job"
                }
            ],
            submitted: false,
            regionArr: RegionJson,
            selectedTwspName: "",
            twspNameJson: TwspNameJson,
            twspName: []
        };
    },

    validations: {
        company_name: {
            required
        },
        category_name: {
            required
        },
        job_title: {
            required,
            maxLength: maxLength(100)
        },
        // min_salary: {
        //     numeric
        // },
        // max_salary: {
        //     numeric
        // },
        job_type: {
            required
        },
        description: {
            required
        },
        short_desc: {
            required
        },
        expired_date: {
            required
        },
        gender: {
            required
        },
        region: {
            required
        },
        // town: {
        //     required
        // },
        address: {
            // required,
            maxLength: maxLength(200)
        }
    },

    methods: {
        onChange(event) {
            var optionValue = event.target.value;
            this.job_type = optionValue;
        },

        onCompanyChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.company_id = optionValue;
            this.company_name = optionText;
        },

        onCategoryChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.category_id = optionValue;
            this.category_name = optionText;
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.region = Value;
            this.selectedTwspName = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.town = Value;
        },
    
        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },

        submit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.jobCreate();
        },

        jobCreate() {
            $("#block-btn").attr("disabled", true);
            var request = {
                company_id: this.company_id,
                category_id: this.category_id,
                job_title: this.job_title,
                min_salary: this.min_salary,
                max_salary: this.max_salary,
                job_type: this.job_type,
                description: this.description,
                short_desc: this.short_desc,
                expired_date: this.expired_date,
                gender: this.gender,
                experience: this.experience,
                qualification: this.qualification,
                // latitude: this.latitude,
                // longitude: this.longitude,
                region: this.region,
                town: this.town,
                address: this.address,
                // facebook_post: this.facebook_post
            };
            axios.post("/job/create", request)
                .then(() => {
                    this.$notification.success("Job Post Added Successfully", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$router.push({
                        name: "jobList"
                    });
                })
                .catch(error => {
                    $("#block-btn").attr("disabled", false);
                    this.$notification.error("Job Adding Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Job Create error", error);
                });
        },

        getCategoryForJob() {
            axios.get("/job/category/list")
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log("Category List API Error", error);
                })
        },

        getCompanyForJob() {
            axios.get("/job/company/list")
                .then(response => {
                    this.company = response.data;
                })
                .catch(error => {
                    console.log("Company List API Error", error);
                })
        }
    },

    mounted() {
        this.getCategoryForJob();
        this.getCompanyForJob();

        // $("#min_salary").on("keypress keyup blur", function (event) {
        //     $(this).val($(this).val().replace(/[^\d].+/, ""));
        //     if ((event.which < 48 || event.which > 57)) {
        //         event.preventDefault();
        //     }
        // });

        // $("#max_salary").on("keypress keyup blur", function (event) {
        //     $(this).val($(this).val().replace(/[^\d].+/, ""));
        //     if ((event.which < 48 || event.which > 57)) {
        //         event.preventDefault();
        //     }
        // });
    }
};
